import capitalize from 'lodash-es/capitalize'
import { FC, useCallback, useMemo } from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { CartContainer } from '../../../../../../brunswick/containers/cart'
import { CartItem } from '../../../../../../types/figs'

import {
  Container,
  DesktopTitle,
  DesktopView,
  List,
  ListItem,
  ListItemTitle,
  MobileText,
  MobileView,
} from './styles'

type Props = {
  productGroupHandle: string
}

export const BagSoFar: FC<Props> = ({ productGroupHandle }) => {
  const { cart } = CartContainer.useContainer()
  const {
    bulk: {
      bagSoFar: { title, items: itemsCta },
    },
  } = useTranslation()

  const lineItemsInCart = useMemo(
    () =>
      Object.values(cart?.items || {}).filter(
        item => item.productGroupHandle === productGroupHandle
      ),
    [cart?.items, productGroupHandle]
  )

  const hasLineItemsInCart = useMemo(() => lineItemsInCart.length > 0, [lineItemsInCart])

  const totalProductGroupQuantity = useMemo(
    () => lineItemsInCart.reduce((acc, item) => acc + item.quantity, 0),
    [lineItemsInCart]
  )

  const formatLineItemAttributes = useCallback((lineItem: CartItem) => {
    const quantity = String(lineItem.quantity)
    const attributes = [lineItem.size, capitalize(lineItem.fit), lineItem.color].filter(
      attr => attr && attr.length > 0
    )

    return `${quantity} ${attributes.join(' / ')}`
  }, [])

  return (
    <Container>
      <MobileView>
        <MobileText>
          {totalProductGroupQuantity} {itemsCta}
        </MobileText>
      </MobileView>
      <DesktopView>
        {hasLineItemsInCart && (
          <List>
            <DesktopTitle>
              {title} ({totalProductGroupQuantity}):
            </DesktopTitle>
            {lineItemsInCart.map(lineItem => (
              <ListItem key={lineItem.key}>
                <ListItemTitle>{formatLineItemAttributes(lineItem)}</ListItemTitle>
              </ListItem>
            ))}
          </List>
        )}
      </DesktopView>
    </Container>
  )
}
